import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'

import { getSimilarProducts, getSimilarProductsLoading } from 'SRC/modules/vehicleParts/detail/selectors'
import { Item } from 'SRC/modules/vehicleParts/list/components/Item'

const SimilarProducts = ({ similarProducts, similarProductsLoading }) => {
	const { t } = useTranslation('common')

	return Array.isArray(similarProducts) && similarProducts.length && !similarProductsLoading ? (
		<section className={`vehicle-part-similar-products`}>
			<h3 className='vehicle-part-similar-products__title'>{t('vehicle_parts_similar_products')}</h3>

			<div className='oglasi'>
				<div className='oglasi-content'>
					<div className='ads-list-grid-view ads-list-grid-view-vehicle-part-similar-products'>
						{similarProducts.map(item => (
							<Item
								item={item}
								isLoading={similarProductsLoading}
								key={item.product_code || item.ean}
							/>
						))}
					</div>
				</div>
			</div>
		</section>
	) : null
}

SimilarProducts.propTypes = {
}

const mapStateToProps = (state) => ({
	similarProducts: getSimilarProducts(state),
	similarProductsLoading: getSimilarProductsLoading(state)
})

export default connect(mapStateToProps)(SimilarProducts)
